"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
var _RentalItem = _interopRequireDefault(require("./RentalItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The RentalPackage model module.
 * @module model/RentalPackage
 * @version 0.0.1
 */
class RentalPackage {
  /**
   * Constructs a new <code>RentalPackage</code>.
   * @alias module:model/RentalPackage
   * @param name {String} 
   * @param beschreibung {String} 
   * @param preis {Number} 
   * @param id {Number} 
   */
  constructor(name, beschreibung, preis, id) {
    RentalPackage.initialize(this, name, beschreibung, preis, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name, beschreibung, preis, id) {
    obj['name'] = name;
    obj['beschreibung'] = beschreibung;
    obj['preis'] = preis;
    obj['id'] = id;
  }

  /**
   * Constructs a <code>RentalPackage</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RentalPackage} obj Optional instance to populate.
   * @return {module:model/RentalPackage} The populated <code>RentalPackage</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RentalPackage();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('items')) {
        obj['items'] = _ApiClient.default.convertToType(data['items'], [_RentalItem.default]);
      }
      if (data.hasOwnProperty('preis')) {
        obj['preis'] = _ApiClient.default.convertToType(data['preis'], 'Number');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('available')) {
        obj['available'] = _ApiClient.default.convertToType(data['available'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>RentalPackage</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RentalPackage</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of RentalPackage.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    if (data['items']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['items'])) {
        throw new Error("Expected the field `items` to be an array in the JSON data but got " + data['items']);
      }
      // validate the optional field `items` (array)
      for (const item of data['items']) {
        _RentalItem.default.validateJSON(item);
      }
      ;
    }
    return true;
  }
}
RentalPackage.RequiredProperties = ["name", "beschreibung", "preis", "id"];

/**
 * @member {String} name
 */
RentalPackage.prototype['name'] = undefined;

/**
 * @member {String} beschreibung
 */
RentalPackage.prototype['beschreibung'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
RentalPackage.prototype['bild'] = undefined;

/**
 * @member {Array.<module:model/RentalItem>} items
 */
RentalPackage.prototype['items'] = undefined;

/**
 * @member {Number} preis
 */
RentalPackage.prototype['preis'] = undefined;

/**
 * @member {Number} id
 */
RentalPackage.prototype['id'] = undefined;

/**
 * @member {Boolean} available
 */
RentalPackage.prototype['available'] = undefined;
var _default = exports.default = RentalPackage;